import type { PayerOption } from '@polarissleep/shared';
import { getConfig } from '../config';
import { getIntakeMedplumClient } from './bot-client';
import { botIdentifier } from './bot-identifier';

export async function searchInsurancePayers(query: string): Promise<PayerOption[]> {
  const client = await getIntakeMedplumClient();
  const result = (await client.executeBot(
    botIdentifier('search-insurance-payers'),
    { query, organizationId: getConfig().organizationId, limit: 25 },
    'application/json'
  )) as { payers?: PayerOption[] };
  return result.payers ?? [];
}
